"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var StyledSvg = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  path,\n  circle,\n  rect {\n    fill: ", ";\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  path,\n  circle,\n  rect {\n    fill: ", ";\n  }\n"])), function (_a) {
    var fontSize = _a.fontSize;
    return fontSize + "px";
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize + "px";
}, function (_a) {
    var color = _a.color;
    return color;
});
var SvgIcon = function (_a) {
    var children = _a.children, _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, _c = _a.color, color = _c === void 0 ? '#FFF' : _c, _d = _a.fontSize, fontSize = _d === void 0 ? '24' : _d, rest = __rest(_a, ["children", "viewBox", "color", "fontSize"]);
    return (react_1.default.createElement(StyledSvg, __assign({ xmlns: "http://www.w3.org/2000/svg", fontSize: fontSize, color: color, viewBox: viewBox }, rest), children));
};
exports.default = SvgIcon;
var templateObject_1;
